import {AfterViewInit, Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {FaqItem, FaqService} from '../../shared/services/faq.service';
import {delay, take} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {ZipcodeService} from '../../shared/services/zipcode.service';
import {ActivatedRoute} from '@angular/router';
import {SeoService} from '../../shared/services/seo.service';
import lottie, {AnimationItem} from 'lottie-web';
import {AnimationOptions} from 'ngx-lottie';
import { CmsPageService } from '../../shared/services/cms-pages.service';

@Component({
    selector: 'app-po-category',
    templateUrl: './po-category.component.html',
    styleUrls: ['./po-category.component.scss'],
})
export class PoCategoryComponent implements OnInit, OnDestroy, AfterViewInit {
    faqs: FaqItem[] | undefined;
    subscriptions: Subscription[] = [];
    zipcode = '';
    pageContent: {[key : string] : string} = {}

    lottieOptions: AnimationOptions = {};
    private animation: AnimationItem;
    constructor(
        private faqService: FaqService,
        private zipcodeService: ZipcodeService,
        private route: ActivatedRoute,
        private seo: SeoService,
        private cmsPages: CmsPageService,
    ) {}

    ngOnInit(): void {
        this.cmsPages.getPageContentBySlug('po-category').subscribe(pageContent => {
            this.pageContent = pageContent
        })

        this.seo.updateTags(
            'Scholenwijzer Den Haag',
            'De Scholenwijzer geeft ouders en kinderen informatie over alle verschillende scholen in Den Haag en omstreken. Dat maakt het kiezen van een school een stuk makkelijker! En er is nog veel meer uit de Scholenwijzer te halen. Hoe weet u welke school het beste past bij u en uw kind? Waar moet u op letten? Hoe werkt het aanmelden? De Scholenwijzer geeft antwoord op al deze vragen en meer.',
        );

        this.faqService
            .getFaqItemsForCategory('PO')
            .pipe(take(1))
            .subscribe(faqs => {
                this.faqs = faqs;

                setTimeout(() => {
                    // @ts-expect-error jerome stuff
                    initJeromeJs();
                }, 0);
            });

        this.subscriptions.push(
            this.zipcodeService.zipcode$.subscribe(value => {
                this.zipcode = value ? value : '';
            }),
            this.route.fragment.pipe(delay(500)).subscribe((id: string) => {
                const scrollTarget = document.getElementById(id);
                if (scrollTarget) {
                    scrollTarget.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                    });
                }
            }),
        );
    }

    ngAfterViewInit() {
        this.animation = lottie.loadAnimation({
            container: document.querySelector('ng-lottie') as Element,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: '/assets/img/svg/category/bo/bo-icoon.json',
        });
    }

    @HostListener('window:scroll', ['$event'])
    onScroll(event: Event): void {
        const scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop ||
            0;
        const docHeight =
            document.documentElement.scrollHeight - document.documentElement.clientHeight;
        const scrollPercent = scrollTop / docHeight;

        const frame = Math.min(Math.max(scrollPercent * 60 * 10, 0), 60 - 1);
        if (this.animation) {
            this.animation.goToAndStop(frame, true);
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
